export class PayInvoiceRequest {

    InvoiceID: number;
    CreditCardID: number;

}